// Shared free-tier gate copy (expansion date window, signal blur, API keys).
export default {
  premium: {
    tag: "PRO",
    gate: {
      signalsTitle: "最新の{n}件のシグナルはロックされています",
      signalsDesc:
        "アップグレードすると、各企業の初日からの拡大シグナルをすべて確認できます。",
      signalsCta: "シグナルのロックを解除",
    },
    dateWindow: {
      tip: "無料プランは直近{n}日間まで対象です。全履歴はアップグレードで解放されます。",
      lockedLabel: "全履歴を見るにはアップグレード",
    },
    apiKeys: {
      bannerTitle: "APIアクセスは有料機能です",
      bannerDesc:
        "キーの発行、エクスポートの自動化、Pubrioへのプログラムからのクエリが可能になります。",
      tip: "APIキーを作成するにはプランをアップグレードしてください。",
      cta: "プランを見る",
    },
    team: {
      locked: "チームを見る",
      tip: "この市場の現地チームを見るにはアップグレードしてください。",
    },
    source: {
      locked: "ソースを見る",
      tip: "各シグナルの出典を開くにはアップグレードしてください。",
    },
    employees: {
      locked: "従業員データはロックされています",
      tip: "この企業の人数と担当者を表示するにはアップグレードしてください。",
      cta: "従業員をアンロック",
    },
    markets: {
      moreLocked: "他 {n} 市場",
    },
  },
};
